import PropTypes from 'prop-types';
import React from 'react';

export const AddToWinnerWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'ADD_TO_WINNER',
    category: 'Position',
    type: 'Add to Winner',
    domain: 'Profit/Loss',
  };
  const quantityBasisValue = softOrder.quantityBasisValue;
  const price = softOrder.price;
  return <Component details={details} price={price} quantityBasisValue={quantityBasisValue} {...rest}/>;
};

AddToWinnerWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    price: PropTypes.any,
    quantityBasisValue: PropTypes.any
  })
};



